// @flow
import React, { Component } from 'react'
import { translations, translateFunc } from '../shared/localize'
import Spinner from './controls/Spinner'
import _ from 'lodash'
import styled, { type StyledComponent } from 'styled-components'
import postJson from '../services/postJson'

const GrayColorOnLoading: StyledComponent<Object, any, any> = styled.div`
  & * {
    ${({ isLoading }: Object) => isLoading && 'color: #aaa;'};
  }
`

const ButtonWithSpinner: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  align-items: center;
`

type Props = {|
  accountId: number,
  updateBalancesPath: string,
  providersBalances: Object
|}

type State = {|
  providersBalances: Object,
  isLoading: boolean
|}

const t = translateFunc(translations.providers_balance)

export default class ProvidersBalance extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      providersBalances: props.providersBalances,
      isLoading: false
    }
  }

  balanceWithCurrency(balance: Object) {
    if (_.isNil(balance['balance'])) {
      return t('no_balance')
    } else {
      return t(balance['currency'], { balance: balance['balance'] })
    }
  }

  changeBalances(balances: Object) {
    this.setState({ providersBalances: balances })
  }

  render() {
    return (
      <div>
        {this.renderDropdown()}
        {this.renderUpdateButton()}
      </div>
    )
  }

  renderDropdown() {
    return (
      <GrayColorOnLoading isLoading={this.state.isLoading}>
        {_.map(this.state.providersBalances, (balance, provider: string) => {
          return (
            <div key={provider} className="balance-b__cash-block" id={`${provider}-balance`}>
              <div className="balance__provider-name">
                <h3>{t(provider)}</h3>
              </div>
              <div className="balance__value">
                <div className="price">{this.balanceWithCurrency(balance)}</div>
              </div>
            </div>
          )
        })}
      </GrayColorOnLoading>
    )
  }

  renderUpdateButton() {
    return (
      <ButtonWithSpinner>
        <button
          className="btn btn-default balance__update"
          disabled={this.state.isLoading}
          onClick={() => this.updateBalance()}
        >
          {t('update')}
        </button>
        {this.state.isLoading && <Spinner className="spinner" />}
      </ButtonWithSpinner>
    )
  }

  updateBalance() {
    if (this.state.isLoading) return
    const { accountId, updateBalancesPath } = this.props
    this.setState({ isLoading: true }, () =>
      postJson(updateBalancesPath, { accountId: accountId })
        .done((response) => {
          this.changeBalances(response['balances'])
        })
        .always(() => {
          this.setState({ isLoading: false })
        })
        .fail(() => {
          window.alert(t('update_failed'))
        })
    )
  }
}
